import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import type { ReactElement } from "react";

export type MenuItem = {
  id: string;
  label: string;
  hint?: string;
  onSelect: () => void;
  disabled?: boolean;
  danger?: boolean;
};

/** Non-modal on purpose: Radix's modal mode injects a <style> element, which the CSP blocks. */
export function Menu({
  label,
  trigger,
  items,
  align = "start",
}: {
  label: string;
  trigger: ReactElement;
  items: MenuItem[];
  align?: "start" | "end";
}) {
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          aria-label={label}
          align={align}
          sideOffset={4}
          className="z-50 min-w-48 rounded-lg border border-line bg-surface p-1 shadow-pop"
        >
          {items.map((item) => (
            <DropdownMenu.Item
              key={item.id}
              disabled={item.disabled}
              textValue={item.label}
              onSelect={item.onSelect}
              className={clsx(
                "flex cursor-pointer items-baseline justify-between gap-6 rounded-md px-2 py-1.5 text-sm outline-none select-none data-[disabled]:cursor-default data-[disabled]:opacity-40 data-[highlighted]:bg-green-wash",
                item.danger ? "text-danger" : "text-ink",
              )}
            >
              <span>{item.label}</span>
              {item.hint ? (
                <span aria-hidden="true" className="text-xs text-ink-3">
                  {item.hint}
                </span>
              ) : null}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
